import React from "react";
import "../../styles/login.css";
import LogoLogin from "../../assets/Logo.png";

const LoginLogo = () => {
  return (
    <div className="login-logo-container">
      <img src={LogoLogin} alt="logo" />
      <h1 className="titulo">
        Bienvenido al Portal de <br />
        <span className="highlight">Gestión Empresarial</span>
      </h1>
      <h2 className="descripcion">Ya puedes acceder a tu espacio de trabajo</h2>
    </div>
  );
};

export default LoginLogo;
